export default {
    items: [
        {
            name: 'Формы',
            url: '/webmaster/webform',
            icon: 'icon-puzzle'
        },

        // {
        //     name: 'Прайс-листы', // НСБ › WEB Мастера › Прайс-листы
        //     url: '/agent/vouchers',
        //     icon: 'icon-puzzle'
        // },

    ]
}
